import React from "react"
import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs"
import { Text } from "../../../components"
import { translate } from "../../../i18n"
import { color, nativeBaseTheme } from "../../../theme"
import { Appearance, ViewStyle } from "react-native"
import { FarmingNotificationScreen, InfoNotificationScreen } from "../../../screens"

const TAB: ViewStyle = {
  paddingHorizontal: 32,
  paddingVertical: 8,
}

export type HomeNotificationNavigatorParamList = {
    'Home.Notification.Info.Price': undefined,
    'Home.Notification.Info.Farm': undefined,
}

const Tab = createMaterialTopTabNavigator<HomeNotificationNavigatorParamList>()

export const NotificationNavigator = () => {
  const colorScheme = "light" || Appearance.getColorScheme()

  return(
    <Tab.Navigator
      screenOptions={{
        tabBarActiveTintColor: colorScheme === 'light' ? color.primary : undefined,
        tabBarItemStyle: TAB,
        lazy: true,
        lazyPreloadDistance: 1
      }}
    >
      <Tab.Screen
        name="Home.Notification.Info.Price"
        component={InfoNotificationScreen}
        options={{
          title: translate('notifications.infoHeader'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="notifications.infoHeader"
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Notification.Info.Farm"
        component={FarmingNotificationScreen}
        options={{
          title: translate('notifications.farmingHeader'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="notifications.farmingHeader"
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
    </Tab.Navigator>
  )
}
